import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import type { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import MultiSelectSortable, {
  ReactSelectOption,
} from '../Selects/SortableSelect';

export interface CompaniesMultiSelectorProps {
  readOnly?: boolean;
  selectedCompanyIds?: string[] | null;
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
  externalReferralOnly?: boolean;
}

export default (props: CompaniesMultiSelectorProps) => {
  const spd = useSpdCore();
  const [companies, setCompanies] = useState<ReactSelectOption[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<ReactSelectOption[]>(
    [],
  );
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    const fetch = props.externalReferralOnly
      ? spd.companies.getAllForExternalReferral()
      : spd.companies.getAll();
    fetch
      .then(all => {
        if (mounted) {
          setCompanies(
            all.map(c => ({
              value: c.id,
              label: c.name + (c.nip ? ' (NIP: ' + c.nip + ')' : ''),
            })),
          );
          setReady(true);
        }
      })
      .catch(err => console.error('Błąd ładowania firm:', err));
    return () => {
      mounted = false;
    };
  }, [spd.companies, props.externalReferralOnly]);

  useEffect(() => {
    if (props.selectedCompanyIds && companies.length > 0) {
      setSelectedOptions(
        companies.filter(c => props.selectedCompanyIds?.includes(c.value)),
      );
    } else {
      setSelectedOptions([]);
    }
  }, [props.selectedCompanyIds, companies]);

  return ready ? (
    <MultiSelectSortable
      options={companies}
      defaultValue={selectedOptions}
      onChange={options => props.onChange && props.onChange(options)}
    />
  ) : (
    <Skeleton />
  );
};
